module.exports = __webpack_public_path__ + "files/9c9017a313819aa54e959ffe8e7d27ea.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300italic.woff
 ** module id = 948
 ** module chunks = 0
 **/